module.exports = __webpack_public_path__ + "img/qrcode_3.002b636.webp";